export function fmtDate(iso, opts) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString(undefined, opts || { dateStyle: 'medium', timeStyle: 'short' });
}

export function fmtDay(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

export function fmtMoney(v) {
  if (v == null) return '$0.00';
  return `$${Number(v).toFixed(2)}`;
}

// Invoices and estimates carry a sequential `number` (INV-1042). Older records
// created before numbering shipped fall back to a short id so nothing renders blank.
export function fmtDocNumber(doc, fallbackPrefix) {
  if (!doc) return '—';
  if (doc.number) return doc.number;
  return `${fallbackPrefix} ${String(doc.id || '').slice(0, 6)}`;
}

export const STATUS_LABELS = {
  scheduled: 'Scheduled',
  on_my_way: 'On my way',
  in_progress: 'In progress',
  finished: 'Finished',
  invoiced: 'Invoiced',
  paid: 'Paid',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export const NEXT_ACTION_LABEL = {
  scheduled: 'On my way',
  on_my_way: 'Start job',
  in_progress: 'Finish job',
  finished: 'Create invoice',
  invoiced: 'Mark paid',
};

export const NEXT_STATUS = {
  scheduled: 'on_my_way',
  on_my_way: 'in_progress',
  in_progress: 'finished',
  finished: 'invoiced',
  invoiced: 'paid',
};

export const JOB_STATES_ORDER = ['scheduled', 'on_my_way', 'in_progress', 'finished', 'invoiced', 'paid'];
